import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

// Create a client with default settings
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000, // Data stays fresh for 30 seconds (prevents HMR refetch spam)
      gcTime: 10 * 60 * 1000, // Cache for 10 minutes
      refetchOnMount: true, // Refetch when mounting if stale
      refetchOnReconnect: true, // Refetch when reconnecting
      retry: false,
    },
  },
});

interface QueryClientContextProps {
  children: ReactNode;
}

export const QueryClientContext = ({ children }: QueryClientContextProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
